import FormikInput from "../../../components/FormikFieldCustom";
import { SendForgotEmailAddress } from "../../../services/auth.service";
import { Formik, Form } from "formik";
import { SendEmailValildationsSchema } from "../../../utils/validations";
import { StatusCodes } from "http-status-codes";
import { toast } from "react-toastify";
import { useState } from "react";
import ButtonLoader from "../../../components/ButtonLoader";
const SentEmail = () => {
  return (
    <div className="flex justify-center items-center flex-col">
      <h1 className="mt-5">Forgot Your Password</h1>
      <Formik
        initialValues={{ email: "" }}
        validationSchema={SendEmailValildationsSchema}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);
          const response = await SendForgotEmailAddress(values);
          if (response.status && response.status_code === StatusCodes.OK) {
            toast.success(response.message);
          } else {
            toast.error(response.message);
          }
          setSubmitting(false);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <FormikInput name="email" label="Email" />
            <button
              type="submit"
              className=" mt-5 border-2 px-1 border-gray-600 bg-gray-400"
            >
              {isSubmitting ? (
                <>
                  <ButtonLoader />
                  Loading...
                </>
              ) : (
                "Send"
              )}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SentEmail;
